/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Component, OnInit, ViewChild} from '@angular/core';

import {Observable} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';

import {Employee} from '../employees/employees.model';
import {EmployeesService} from '../employees/employees.service';
import {Image, ImageCropperComponent} from '../files';
import {ModalCommand, ModalState} from '../modal';

@Component({
  selector: 'gp-user-avatar-cropper',
  template: `
    <gp-modal [closable]="true"
              [onSubmit]="submitCallback"
              [onCancel]="cancelCallback">
      <div class="gp-modal-title">
        {{ 'EMPLOYEE_FORM.crop_photo' | translate }}
      </div>
      <div class="gp-modal-body">
        <gp-image-cropper #cropper [file]="photoForUpload"></gp-image-cropper>
      </div>
    </gp-modal>
  `
})
export class UserAvatarCropperComponent implements OnInit {

  public employee: Employee;
  public photoForUpload: File;
  public cancelCallback: () => Promise<void>;
  public submitCallback: () => Observable<ModalCommand>;

  @ViewChild('cropper', {static: true})
  public cropper: ImageCropperComponent;

  constructor(private employeesService: EmployeesService) {
  }

  public ngOnInit() {
    this.cancelCallback = this.onCancel.bind(this);
    this.submitCallback = this.onSubmit.bind(this);
  }

  public onCancel(): Promise<void> {
    return Promise.resolve();
  }

  private onSubmit(): Observable<ModalCommand> {
    return this.cropper.getResult()
      .pipe(
        switchMap((image: Image) => {
          return this.employeesService.changePicture(this.employee, image).pipe(
            map(() => ({
                state: ModalState.VALID,
                message: 'OK',
                duration: 1000
              })
            ));
        })
      );
  }
}
